import { action, computed, observable, values } from 'mobx';

export default class ChooseYourPriceStore {
  @observable sessions = [];
  @observable chosenSession = null;
  @observable tickets = false;
  @observable loading = false;
  @observable numTickets = null;
  @observable chosenTicket = null;

  constructor(eventId, eventName, bookingUrl, nonCYPId, goToCartBtnText, cartPageUrl, continueBtnText, cartExpiryText) {
    this.eventId = eventId;
    this.eventName = eventName;
    this.bookingUrl = bookingUrl;
    this.nonCYPId = nonCYPId;
    this.goToCartBtnText = goToCartBtnText;
    this.cartPageUrl = cartPageUrl;
    this.continueBtnText = continueBtnText;
    this.cartExpiryText = cartExpiryText;
    this.allocatedSeating = false;
  }

  @computed
  get hasSessions() {
    return this.sessions.length;
  }

  @computed
  get hasTickets() {
    return this.tickets;
  }

  @computed
  get hasAllocatedSeating() {
    return this.allocatedSeating;
  }

  @computed
  get isLoading() {
    return this.loading;
  }

  @computed
  get getSessions() {
    return values(this.sessions);
  }

  @computed
  get getTickets() {
    return values(this.tickets);
  }

  @action
  setSessions = (sessions) => {
    this.sessions = sessions;
  }

  @action
  setChosenSession = (session) => {
    this.chosenSession = session;
  }

  @action
  setChosenTicket = (ticket) => {
    this.chosenTicket = ticket;
  }

  @action
  setNumTickets = (numTickets) => {
    this.numTickets = numTickets;
  }

  @action
  setLoading = (loading) => {
    this.loading = loading;
  }

  @action
  setTickets = (tickets) => {
    this.tickets = tickets;
  }

  @action
  setHasAllocatedSeating = (hasAllocatedSeating) => {
    this.allocatedSeating = hasAllocatedSeating;
  }
}
